(function () {
    'use strict';

    function initShatnezMediaPage() {
        const pageRoot = document.querySelector('.js-shatnez-media');
        if (!pageRoot) {
            return;
        }

        const playlistId = (pageRoot.dataset.jwPlaylistId || '').trim();
        const videoList = pageRoot.querySelector('[data-jw-video-list]');
        const videoTitle = pageRoot.querySelector('[data-jw-current-title]');
        const videoMessage = pageRoot.querySelector('[data-jw-message]');
        const playerFrame = pageRoot.querySelector('.shatnez-media-page__player-frame');

        const setMessage = (message) => {
            if (videoMessage) {
                videoMessage.textContent = message;
            }
        };

        const setActiveVideo = (item, button, buttons) => {
            if (!item || !playerFrame) {
                return;
            }

            playerFrame.src = `https://cdn.jwplayer.com/players/${item.mediaid}.html`;

            if (videoTitle) {
                videoTitle.textContent = item.title || '';
            }

            if (buttons && buttons.length) {
                buttons.forEach((btn) => {
                    btn.classList.remove('is-active');
                    btn.setAttribute('aria-pressed', 'false');
                });
            }

            if (button) {
                button.classList.add('is-active');
                button.setAttribute('aria-pressed', 'true');
            }
        };

        const buildPlaylistButtons = (items) => {
            if (!videoList) {
                return;
            }

            videoList.innerHTML = '';

            const buttons = items.map((item, index) => {
                const button = document.createElement('button');
                button.type = 'button';
                button.className = 'shatnez-media-page__video-item';
                button.setAttribute('aria-pressed', 'false');

                const thumb = document.createElement('span');
                thumb.className = 'shatnez-media-page__video-thumb';
                if (item.image) {
                    thumb.style.backgroundImage = `url(${item.image})`;
                }

                const title = document.createElement('span');
                title.className = 'shatnez-media-page__video-item-title';
                title.textContent = item.title || `Video ${index + 1}`;

                button.appendChild(thumb);
                button.appendChild(title);

                button.addEventListener('click', () => {
                    setActiveVideo(item, button, buttons);
                    if (playerFrame) {
                        playerFrame.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });

                videoList.appendChild(button);
                return button;
            });

            if (items.length > 0) {
                setActiveVideo(items[0], buttons[0], buttons);
            }
        };

        if (!playlistId) {
            setMessage('No playlist configured yet. Add a JW Playlist ID in the page fields.');
        } else {
            setMessage('Loading videos...');
            fetch(`https://cdn.jwplayer.com/v2/playlists/${playlistId}`)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Playlist request failed');
                    }
                    return response.json();
                })
                .then((payload) => {
                    const playlist = Array.isArray(payload.playlist) ? payload.playlist : [];
                    const validItems = playlist.filter((item) => item && item.mediaid);

                    if (!validItems.length) {
                        throw new Error('Playlist is empty');
                    }

                    buildPlaylistButtons(validItems);
                    setMessage('');
                })
                .catch(() => {
                    setMessage('Unable to load videos right now. Please verify the playlist ID.');
                });
        }

        const modal = pageRoot.querySelector('[data-gallery-modal]');
        const tiles = Array.from(pageRoot.querySelectorAll('[data-gallery-image]'));
        const modalImage = pageRoot.querySelector('[data-gallery-modal-image]');
        const modalClose = pageRoot.querySelector('[data-gallery-close]');
        const modalPrev = pageRoot.querySelector('[data-gallery-prev]');
        const modalNext = pageRoot.querySelector('[data-gallery-next]');

        let activeTileIndex = -1;

        const openModal = (index) => {
            if (!modal || !modalImage || !tiles[index]) {
                return;
            }

            const tile = tiles[index];
            const imageUrl = tile.getAttribute('data-gallery-image') || '';
            const imageAlt = tile.getAttribute('data-gallery-alt') || '';

            if (!imageUrl) {
                return;
            }

            activeTileIndex = index;
            modalImage.src = imageUrl;
            modalImage.alt = imageAlt;
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('modal-open');
        };

        const closeModal = () => {
            if (!modal || !modalImage) {
                return;
            }

            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            modalImage.src = '';
            modalImage.alt = '';
            document.body.classList.remove('modal-open');
        };

        const moveModal = (step) => {
            if (!tiles.length) {
                return;
            }

            const nextIndex = (activeTileIndex + step + tiles.length) % tiles.length;
            openModal(nextIndex);
        };

        tiles.forEach((tile, index) => {
            tile.addEventListener('click', () => openModal(index));
        });

        if (modalClose) {
            modalClose.addEventListener('click', closeModal);
        }

        if (modalPrev) {
            modalPrev.addEventListener('click', () => moveModal(-1));
        }

        if (modalNext) {
            modalNext.addEventListener('click', () => moveModal(1));
        }

        if (modal) {
            modal.addEventListener('click', (event) => {
                if (event.target === modal) {
                    closeModal();
                }
            });
        }

        document.addEventListener('keydown', (event) => {
            if (!modal || !modal.classList.contains('is-open')) {
                return;
            }

            if (event.key === 'Escape') {
                closeModal();
            }

            if (event.key === 'ArrowLeft') {
                moveModal(-1);
            }

            if (event.key === 'ArrowRight') {
                moveModal(1);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initShatnezMediaPage);
    } else {
        initShatnezMediaPage();
    }
})();
